<template>
  <div>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column label="名字">
            <template slot-scope="scope">
              <span :style="setFontColor(scope.row.FLAG)">
                {{ scope.row.NAME }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="过期日期">
            <template slot-scope="scope">
              <span :style="setFontColor(scope.row.FLAG)">
                {{ scope.row.EXPIRE_DATE }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button icon="el-icon-view" size="small" @click="openImage(scope.row)" type="text">查看资质凭证</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { supplierContractFun } from 'api/systemSetting';

export default {
  data() {
    return {
      formLableWidth: '100px',
      tableData: [],
      addFormVisible: false,
      addForm: {},
    };
  },
  methods: {
    // ------------------------------新增
    addContract() {
      this.addFormVisible = true;
    },
    setFontColor(e) {
      if (e === 1) {
        return {
          color: '#FF7F00',
        };
      } if (e === 2) {
        return {
          color: '#FF0000',
        };
      }
    },
    openImage(row) {
      this.$router.push({ name: 'contractImage' });
      sessionStorage.setItem('qualifyId', row.ID);
    },
    // -------------------------------初始化数据
    queryContract() {
      supplierContractFun()
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result;
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // close(formName) {
    //     this.$refs[formName].resetFields()
    //     let modalName = formName + 'Visible'
    //     this[`${modalName}`] = false
    //     // this.fileList = []
    // }
  },
  created() {
    this.queryContract();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/foodSecurity/contractManage.vue